export const ActionTypes = {
  SET_PROJECT: "SET_PROJECT",
  CLEAR_PROJECT: "CLEAR_PROJECT",
  GET_PROJECTS: "GET_PROJECTS",
  GET_PROJECTS_SUCCESS: "GET_PROJECTS_SUCCESS",
  GET_PROJECTS_ERROR: "GET_PROJECTS_ERROR",
  GET_PROJECT: "GET_PROJECT",
  GET_PROJECT_SUCCESS: "GET_PROJECT_SUCCESS",
  GET_PROJECT_ERROR: "GET_PROJECT_ERROR",
  GET_PROJECT_LICENSES: "GET_PROJECT_LICENSES",
  ADD_PROJECT: "ADD_PROJECT",
  ADD_PROJECT_SUCCESS: "ADD_PROJECT_SUCCESS",
  ADD_PROJECT_ERROR: "ADD_PROJECT_ERROR",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  UPDATE_PROJECT_SUCCESS: "UPDATE_PROJECT_SUCCESS",
  UPDATE_PROJECT_ERROR: "UPDATE_PROJECT_ERROR",
  DELETE_PROJECT: "DELETE_PROJECT",
  DELETE_PROJECT_SUCCESS: "DELETE_PROJECT_SUCCESS",
  DELETE_PROJECT_ERROR: "DELETE_PROJECT_ERROR",
  RESET_PROJECT: "RESET_PROJECT",
  SET_FILTER_PROJECTS: "SET_FILTER_PROJECTS",
  SET_SEARCH_PROJECTS: "SET_SEARCH_PROJECTS",
  GET_PROJECT_JOBS_STATUS_LOADING: "GET_PROJECT_JOBS_STATUS_LOADING",
  GET_PROJECT_JOBS_STATUS_SUCCESS: "GET_PROJECT_JOBS_STATUS_SUCCESS",
  GET_PROJECT_JOBS_STATUS_ERROR: "GET_PROJECT_JOBS_STATUS_ERROR",
} as const;
